// Copyright ©️ 2026 eVolve MEP, LLC

import { Spoiler, Text } from '@mantine/core';

type Props = {
  description: string;
};

/**
 * Read-only view of an entity's long-form description on a detail page. Shows the first few lines and, when the text
 * overflows, a control to expand it. Always starts collapsed, so leaving the page and coming back collapses it again.
 */
export const CollapsibleDescription = ({ description }: Props) => (
  <Spoiler maxHeight={150} showLabel="View full description" hideLabel="Show less">
    <Text style={{ whiteSpace: 'pre-wrap' }}>{description}</Text>
  </Spoiler>
);
